import { JobTypeModel } from '../ts/interfaces/models/JobTypeModel';
import { BaseService } from './baseService';

class JobTypeService extends BaseService<JobTypeModel> {
  controllerName = 'jobTypes';
}

export const jobTypeService = new JobTypeService();
